import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import MbCheckList from 'components/molecules/MbCheckList';
import Popover from 'components/molecules/Popover';

const fliterStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 617,
  },
  contentWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
}));

const returnSelectedLabel = (filterArray, payFilterList) => {
  let resultStr = '';
  const codeNameArray = [];
  for (let i = 0; i < filterArray.length; i++) {
    const selectedCode = filterArray[i];
    for (let i = 0; i < payFilterList.length; i++) {
      if (payFilterList[i].CODE_ID === selectedCode) {
        codeNameArray.push(payFilterList[i].CODE_DESC);
        break;
      }
    }
  }
  resultStr = codeNameArray.join(', ');
  return resultStr;
};

const makeCheckListComponent = (
  classes,
  filterList,
  filterArray,
  handleOnClickFilter
) => {
  const handleOnClick = (value) => {
    let checked = true;
    if (filterArray.includes(value)) {
      // 기존에 있던 값이면 빼기
      checked = false;
    }
    handleOnClickFilter(filterArray, value, checked);
  };

  return (
    <div className={classes.contentWrap}>
      {(() => {
        const result = [];
        for (let item of filterList) {
          const { CODE_DESC, CODE_ID } = item;
          let checked = false;
          if (filterArray.includes(CODE_ID)) {
            checked = true;
          }

          result.push(
            <MbCheckList
              key={`${CODE_DESC}_${CODE_ID}`}
              label={CODE_DESC}
              onClick={() => handleOnClick(CODE_ID)}
              checked={checked}
            />
          );
        }
        return result;
      })()}
    </div>
  );
};

const PayTypeFilterBox = ({
  filterList,
  filterArray,
  handleOnClickFilter,
  label,
}) => {
  const classes = fliterStyles();
  return (
    <>
      {filterList.length !== 0 && (
        <Popover
          label={label}
          // getOnClose={getOnClose}
          selectedLabel={returnSelectedLabel(filterArray, filterList)}
          filtered={filterArray.length !== 0}
          filterList={makeCheckListComponent(
            classes,
            filterList,
            filterArray,
            handleOnClickFilter
          )}
          popoverHeight={435}
          createOnOpen
        />
      )}
    </>
  );
};

export default PayTypeFilterBox;
